module.exports = __webpack_public_path__ + "06_long_beige.34bd06f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_long_beige.png
// module id = wiqq
// module chunks = 0